import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// Bevarar inline-stilar (t.ex. font-size) från rich text-innehåll som annars
// tas bort av Angulars sanitizer vid [innerHtml]-bindning.
@Pipe({
  name: 'safeHtml',
  standalone: false,
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    // eslint-disable-next-line sonarjs/no-angular-bypass-sanitization -- caller must guarantee value is trusted/editor-authored HTML, never end-user input
    return this.sanitizer.bypassSecurityTrustHtml(value ?? '');
  }
}
